import { http } from '@/api/Connect';
import { BASE } from '@/api/CopyStake/BaseUrls';
import { AxiosResponse } from 'axios';

import { TCopyStakeGuidanceListResponse, TGuidance } from '@/api/schema';

const API_GUIDANCE = {
  LIST(): string {
    return `${BASE()}/guidance`; //GET
  },
  GUIDANCE(guidanceId: string | number): string {
    return `${BASE()}/guidance/${guidanceId}`; //GET
  },
  UPLOAD(): string {
    return `${BASE()}/guidance`; //POST
  },
  UPDATE(guidanceId: string | number): string {
    return `${BASE()}/guidance/${guidanceId}`; //PUT
  },
  DELETE(guidanceId: string | number): string {
    return `${BASE()}/guidance/${guidanceId}`; //DELETE
  }
};

export async function getGuidanceList(): Promise<TCopyStakeGuidanceListResponse> {
  return http
    .get(API_GUIDANCE.LIST(), { cacheTime: 0 })
    .then(({ data }: AxiosResponse<TCopyStakeGuidanceListResponse>) => data);
}

export async function uploadGuidance(payload: FormData): Promise<TGuidance> {
  return http.post(API_GUIDANCE.UPLOAD(), payload).then(({ data }) => data);
}

export async function getGuidance(
  guidanceId: number | string
): Promise<TGuidance> {
  return http
    .get(API_GUIDANCE.GUIDANCE(guidanceId), { cacheTime: 0 })
    .then(({ data }: AxiosResponse<TGuidance>) => data);
}

export async function updateGuidance(
  guidanceId: number | string,
  payload: FormData
): Promise<TGuidance> {
  return http
    .put(API_GUIDANCE.UPDATE(guidanceId), payload)
    .then(({ data }) => data);
}

export async function deleteGuidance(
  guidanceId: number | string
): Promise<void> {
  return http.delete(API_GUIDANCE.DELETE(guidanceId));
}
